import React, { useContext, createContext, useReducer, useEffect, useMemo } from "react";
import axios from "axios";
import { testVideos } from "../testdata";

const reducer = (state, action) => {
	switch (action.type) {
		case "UPDATE_FILTER":
			return {
				...state,
				filter: action.payload,
			};
		case "UPDATE_CATS":
			return {
				...state,
				allCats: action.payload,
			};
		case "UPDATE_VIDEOS":
			return {
				...state,
				results: action.payload,
			};
		case "UPDATE_SEARCH":
			return {
				...state,
				search: action.payload,
			};
		case "UPDATE_FETCH":
			return {
				...state,
				fetching: action.payload,
			};
		case "UPDATE_TOGGLE":
			return {
				...state,
				toggle: action.payload,
			};
		default:
			return state;
	}
};

export const StateContext = createContext([]);

const setInitialState = async (state, dispatch) => {
	dispatch({ type: "UPDATE_FETCH", payload: true });
	// const response = { data: testVideos };
	let response;
	try {
		response = await axios.get("https://sourcesofstrength.org/wp-json/sos-videos/v1/videos");
	} catch (error) {
		console.error(error);
		response = error;
	}

	const catFilteredVideos = state.catQuery
		? filterVideosByCategory(response.data.allVideos, state.catQuery)
		: response.data.allVideos;

	dispatch({ type: "UPDATE_VIDEOS", payload: catFilteredVideos });
	dispatch({ type: "UPDATE_FILTER", payload: catFilteredVideos });
	dispatch({ type: "UPDATE_CATS", payload: response.data.cats });
	dispatch({ type: "UPDATE_FETCH", payload: false });

	// const toggle = response.data.allVideos.reduce(function (prev, singleVideo) {
	// 	prev[singleVideo.id] = false;
	// 	return prev;
	// }, {});

	// dispatch({ type: "UPDATE_TOGGLE", payload: toggle });
};

export const FilterProvider = (props) => {
	const { cat } = props;
	const initialState = {
		filter: [],
		results: [],
		allCats: [],
		type: "",
		search: "",
		fetching: true,
		catQuery: cat,
		toggle: "",
	};
	const [state, dispatch] = useReducer(reducer, initialState);
	useEffect(() => {
		setInitialState(state, dispatch);
	}, []);

	const value = useMemo(() => [state, dispatch], [state]);

	return <StateContext.Provider value={value} {...props} />;
};

export const filterVideosByCategory = (videos, category) => {
	let result = [];
	videos.map((video) => {
		video.cat.length > 0
			? video.cat.map((single) => {
					if (single.slug === category) {
						return result.push(video);
					}
			  })
			: video.cat === category && result.push(video);
	});
	return result;
};

export const useFilterContext = () => useContext(StateContext);
